import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
} from "reactstrap";
// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import showNotification from "../../../../helpers/show_notification";
import printDiv from "../../../../helpers/print_data";

const ViewInventory = (props) => {
  const { SearchBar } = Search;

  const store_id = localStorage.getItem("store_id")

  useEffect(() => {
    loadAllEquipments();
  }, []);

  const [allEquipments, setAllEquipments] = useState([]);
  const loadAllEquipments = async () => {
    let payload = {store_id:store_id};   
    let url = process.env.REACT_APP_BASEURL + "storeequipmentinventories/get_by_store_id";
    const response = await postSubmitForm(url, payload);
    if (response && response.status === 1) {
      setAllEquipments(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };


  const [transactionsModal, setTransactionsModal] = useState();
  const [selectedItem, setSelectedItem] = useState();
  const [selectedItem_Transactions, setSelectedItem_Transactions] = useState([]);

  const handleViewDetailsClick = async (row) => {
    let url = process.env.REACT_APP_BASEURL + "storeequipmentinventories/get_by_equipment_id_for_store";
    const response = await postSubmitForm(url, { equipment_id: row._id });
    if (response && response.status === 1) {
      setSelectedItem_Transactions(response.data);
      setSelectedItem(row);

      setTransactionsModal(!transactionsModal);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [selectedItemToAdd, setSelectedItemToAdd] = useState();
  function editFormatter(cell, row) {
    return (
      <>
        <span className="text-info mr-2">
          <i
            className="mdi mdi-text-box-search font-size-15"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              handleViewDetailsClick(row);
            }}
          ></i>
        </span>
        {/* <span className="text-info">
          <i
            className="mdi mdi-cart-plus font-size-15"
            title="Add Inventory"
            style={{ cursor: "pointer" }}
            onClick={() => {
              setSelectedItemToAdd( handleDestructure(row));
              // setSelectedItemToAdd( row);
              setAddInventoryModal(!addInventoryModal);
            }}
          ></i>
        </span> */}
      </>
    );
  }

  function handleDestructure (row){
    // console.log(row);
    const updatedData = {
      _id: row._id,
      name: row.name,
      label: row.name,
      cost_price: row.cost_price,
      category: row.category,
      sub_category: row.sub_category,
      brand: row.brand,
      unit: row.unit,
      available: row.available_in_unit,
    };
    return updatedData
  }
  

  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "3%" };
      },
    },
    {
      text: props.t("Name"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    {
      dataField: "category",
      text: props.t("Category"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
  
    {
      dataField: "threshold",
      text: props.t("Threshold"),
      sort: true,
      formatter:(cell,row)=>{
         return row.threshold+" "+row.unit
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "available_in_unit",
      text: props.t("Available"),
      sort: true,
      formatter:(cell,row)=>{
        return row.available_in_unit < row.threshold ? (
          <span className="font-size-12 badge-soft-danger badge badge-danger badge-pill mr-1 mb-1">
            {row.available_in_unit + " " + row.unit}
          </span>
            ) : (
              <>
               {row.available_in_unit + " " + row.unit}

              </>
            );      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },

    {
      text: props.t("Action"),
      formatter: editFormatter,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
    },
  ];
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );

  const columns_transaction = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      text: props.t("Batch"),
      dataField: "batch",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "quantity",
      text: props.t("Quantity"),
      formatter: (cell, row) => {
        return row.quantity+" "+row.equipment_details?.unit
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },

    {
      dataField: "cost_price",
      text: props.t("Cost Price"),
      formatter:(cell,row)=>{
        return row.cost_price +  "/" + row.equipment_details?.unit
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    
    {
      dataField: "remarks",
      text: props.t("Remarks"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    
    {
      dataField: "",
      text: props.t("Entry Date"),
      sort: false,
      formatter: (cell, row) => {
        return moment(row.createdAt).format("DD/MM/YYYY HH:mm");
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    // {
    //   text: props.t("Transfer"),
    //   formatter: (cell, row) => {
    //     if(row.remarks !== "Transferred from Central Store")
    //     return (
    //       <span className="text-info">
    //         <i
    //           className="bx bx-transfer font-size-22"
    //           title="Transfer"
    //           style={{ cursor: "pointer" }}
    //           onClick={() => {
    //             setSelectedBatch(row);
    //             setTransferModal(!transferModal);
    //           }}
    //         ></i>
    //       </span>
    //     );
    //   },
    //   sort: false,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "7%" };
    //   },
    // },
  ];
  const pagination_options = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "200",
        value: 200,
      },
      {
        text: "All",
        value: selectedItem_Transactions && selectedItem_Transactions.length,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
    hideSizePerPage: true,
    ignoreSinglePage: true,
  };

  const [addInventoryModal, setAddInventoryModal] = useState(false);

  const handleClosePopup = async () => {
    setAddInventoryModal(!addInventoryModal);
  };



  const handleDownload = async () => {
    const fileName = "equipment_inventory";
    const exportType = "xls";

    let data_to_export = allEquipments;

    if (data_to_export) {
      var data = [];
      data_to_export.forEach(function (v) {
        data.push({
          Name: v.name,
          Brand: v.brand,
          Category: v.category,
          sub_category: v.sub_category,
          Unit: v.unit,
          Available: v.available_in_unit + " "+v.unit,
          Threshold: v.threshold
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            title={props.t("Inventory")}
            breadcrumbItem1={props.t("Equipments")}
            breadcrumbItem2={props.t("View Inventory")}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>{props.t("View Inventory")} </CardTitle>
                  <CardSubtitle className="mb-3">
                    {props.t("View all equipments in your inventory here")}
                  </CardSubtitle>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div id="printDiv">
                    <ToolkitProvider
                      bootstrap4
                      keyField="_id"
                      data={allEquipments && allEquipments}
                      // data={data && data}
                      columns={columns}
                      noDataIndication={props.t("No data to display.")}
                      search
                    >
                      {(props) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...props.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4}></Col>
                            <Col lg={4} className="text-right">
                              {/* <button
                              className="btn-sm btn btn-info"
                              onClick={() => {
                                setAddInventoryModal(!addInventoryModal);
                              }}
                            >
                              Add Item
                            </button> */}
                            </Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            {...props.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>

                  <Modal
                    size="lg"
                    style={{
                      width: "940px",
                      maxWidth: "950px",
                    }}
                    isOpen={transactionsModal}
                    toggle={() => setTransactionsModal(!transactionsModal)}
                  >
                    <ModalHeader
                      toggle={() => setTransactionsModal(!transactionsModal)}
                    >
                      Equipment Name: 
                      <strong> {selectedItem && selectedItem.name} </strong>
                    </ModalHeader>
                    <ModalBody>
                      {selectedItem && (
                        <>
                          <Row>
                            <Col lg={12}>
                              <Card>
                                <CardBody>
                                  <Row>
                                    <Col lg={12}>
                                      <ToolkitProvider
                                        keyField="_id"
                                        data={
                                          selectedItem_Transactions &&
                                          selectedItem_Transactions
                                        }
                                        columns={columns_transaction}
                                      >
                                        {(props) => (
                                          <div>
                                            <BootstrapTable
                                              {...props.baseProps}
                                              pagination={paginationFactory(
                                                pagination_options
                                              )}
                                              noDataIndication="No data to display."
                                              striped
                                              hover
                                              condensed
                                            />
                                          </div>
                                        )}
                                      </ToolkitProvider>
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </>
                      )}
                    </ModalBody>
                  </Modal>
                  <Modal
                    size="lg"
                    style={{
                      width: "940px",
                      maxWidth: "950px",
                    }}
                    isOpen={addInventoryModal}
                    toggle={() => setAddInventoryModal(!addInventoryModal)}
                  >
                    <ModalHeader
                      toggle={() => setAddInventoryModal(!addInventoryModal)}
                    >
                      Add Item
                    </ModalHeader>
                    <ModalBody>
                      {/* <AddInventoryComp
                        isRefreshData={true}
                        refreshData={loadAllEquipments}
                        selectedItem={selectedItemToAdd}
                        handleClosePopup={handleClosePopup}
                      /> */}
                    </ModalBody>
                  </Modal>
           
    
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(ViewInventory))
);
